import React, { Component } from 'react';


import NumberFormat from 'react-number-format';
import {transactionID, clientInfo, notification, validCpf} from '../../../services/helpers';
import axios from 'axios';
import Card from 'react-credit-cards';
import Swal from 'sweetalert2';

import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatFormData,
} from '../../../Components/utils';




class AddCard extends Component {

    constructor(props) {
        super(props);

        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo().accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            name: '',
            number: '',
            expiry: '',
            cvv: '',
            cpf: '',
            focused: '',
        }
    }

    handleInputFocus = ({ target }) => {
        this.setState({
            focused: target.name,
        });
    };

    handleInputChange = ({ target }) => {
        switch(target.name) {
            case 'number':
                target.value = formatCreditCardNumber(target.value).replace(/\s/g, '');
                break;
            case 'expiry':
                target.value = formatExpirationDate(target.value);
                break;
            case 'cvc':
                target.name = 'cvv';
                target.value = target.value.substr(0, 4);
                break;
        }

        this.setState({ [target.name]: target.value });
    };

  

    validCard() {

        const { number, name, expiry, cvv, cpf } = this.state;

        if (number === "" || number.length < 16) {
            notification('error', 'Escolha o cartão!')
            return false;
        }

        if (name === "") {
            notification('error', 'Escolha o nome do titular!')
            return false;
        }

        if (expiry === "" || expiry.length < 4) {
            notification('error', 'Escolha a data de vencimento!')
            return false;
        }

        if (expiry.slice(0, 2) < 1 || expiry.slice(0, 2) > 12) {
            notification('error', 'Data de vencimento inválida!')
            return false;
        }

        if (cvv === "" || cvv.length === 0) {
            notification('error', 'Digite o CVV!')
            return false;
        }

        if (cpf.trim().length === 0) {
            notification('error', 'Digite o cpf!')
            return false;
        }

        if (!validCpf(cpf)) {
            notification('error', 'CPF inválido!')
            return false;
        }
        return true;
    }

    handleAddCard = (paymentId) => {
        const {number} = this.state;

        const {paymentType} = this.props;

        const digFour = number.substring(number.length -4);
        const flag = number.substring(1) === 5 ? 'Visa' : 'Mastercard';

        

        const paymentState = {
            digFour: digFour,
            flag: flag,
            id: paymentId,
            type: paymentType,

        }
        this.props.handlePayment(paymentState);
    }


    addCard = async () => {
        try {
            if (!this.validCard()) return false;
            const {name, number, expiry, cvv, cpf, focused} = this.state;
            const {paymentType} = this.props; 

            this.props.handleLoading(1);

            const response = await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/addCard', {
                transactionId: transactionID('ACE'),
                msisdn: clientInfo().number,
                paymentType: paymentType,
                cardNumber: number,
                expiration: expiry,
                cvv: cvv,
                cpf: cpf,
                name: name
            });

            switch(response.data.code) {
                case 'P00':
                    this.props.handleLoading(0);
                    this.handleAddCard(response.paymentID);
                    break;
                case 'P05':
                default:
                    notification('error', response.data.msg);
                    break;
            }

           

        }catch(exception) {
           
            
            this.props.handleLoading(0);
            if(exception.response) {
                notification('error', exception.response.msg);
                return false;
            }

            notification('error', 'Não foi possível adicionar o cartão');
        }

    }

   

    componentDidMount = async () => {

    }

    render() {

        const {name, number, expiry, cvv, cpf, focused} = this.state;
        const {paymentType} = this.props; 

        return (

            <div className="choose-debitcard card-container">
                <h2>{paymentType === 'D' ? 'Cartão de débito' : 'Cartão de crédito'}</h2>
                <div className="card-content">
                    <div className="content-payment-body-info">
                        <form>
                            <label>Número do cartão</label>
                            <NumberFormat
                                type="text"
                                name="number"
                                placeholder="5555 **** **** 7181"
                                required
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                                format="####.####.####.####"
                            />

                            <label>Nome titular</label>
                            <input
                                type="text"
                                name="name"
                                placeholder="José da Silva"
                                required
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus} />

                            <div className="both-info">
                                <div>

                                    <label>Data de vencimento</label>
                                    <NumberFormat
                                        type="text"
                                        name="expiry"
                                        placeholder="04/21"
                                        pattern="\d\d/\d\d"
                                        required
                                        onValueChange={(values) => {
                                            const { value } = values;
                                            this.setState({ expiry: value });
                                        }}
                                        onFocus={this.handleInputFocus}
                                        format="##/##"
                                    />

                                </div>
                                <div>

                                    <label>CVV</label>
                                    
                                    <input
                                        type="text"
                                        name="cvc"
                                        placeholder="***"
                                        pattern="\d{3,4}"
                                        maxLength={4}
                                        required
                                        onChange={this.handleInputChange}
                                        onFocus={this.handleInputFocus} />

                                </div>
                            </div>

                            <label>CPF</label>
                            <NumberFormat
                                value={cpf}
                                placeholder="123.456.789-10"
                                onValueChange={(values) => {
                                    const { value } = values;
                                   
                                    this.setState({ cpf: value});
                                }}
                                format="###.###.###-##"
                            />

                        </form>
                    </div>

                    <div className="content-payment-body-card">
                        <Card
                            number={number}
                            name={name}
                            expiry={expiry}
                            cvc={cvv}
                            focused={focused}
                        />
                    </div>
                </div>
                <div className="container-btn-add">
                    <button className="btn btn-cancel" onClick={() => { this.props.setPaymentType('') }}>Cancelar</button>
                    <button className="btn btn-success" onClick={() => { this.addCard() }}>Salvar</button>
                </div>
            </div>

        );
    }

}

export default AddCard